//TODO:  validate input on color attribute    info,warning,danger,success --- should we name differently? 
//  what about other colors   use ThemeColor1, ThemeColor2, etc?

import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { Store } from '@ngxs/store';
import { SetSectionLayout } from '@Core/models/proprietary/page/page.actions';
import { PageSection, SectionLayoutType } from '@Core/models/proprietary/page/page.state';
import { getHtmlElementPosition } from 'src/ep-utils';

@Component({
    standalone: false,
    selector: 'ep-panel',
    templateUrl: './panel.component.html',
    styles: ['.panel-wrapper { margin: 5px }']
})
export class PanelComponent {
    private _badgeText = '';
    private _minBodyHeight = null;
    private updateLayoutTimeout = null;

    protected position = { x: 0, y: 0 };
    public _minBodyHeightFormula = null;

    @ViewChild('panelContent', { static: false })
    private pageContentElement: ElementRef;

    @Input()
    title: string = '';

    @Input()
    subtitle: string = '';

    @Input()
    icon: string = '';

    @Input()
    showIcon: Boolean = false;

    @Input()
    badgeColor: string = '';

    @Input()
    iconSecondary: string = ''; //secondary icon to the right of title -- used for special indicators

    @Input()
    iconSecondaryTooltip: string = null; //tool tip for secondary icon to the right of title

    @Input()
    panelType = 'shaded'; //box, shaded, transparent, frame

    @Input()
    set badgeText(value: string) {
        if (!value) {
            this._badgeText = '';
            return;
        }
        if (value == '') {
            this._badgeText = '';
            return;
        }
        this._badgeText = value;
        return;
    }

    @Input()
    allowCollapse: boolean = false;

    @Input()
    collapsed: boolean = false;

    @Input()
    pageSection: PageSection;

    @Input()
    set minBodyHeight(value: string) {
        //value can be in the form of 'fill-remaining' or '200px' or any valid html height value.
        this._minBodyHeight = value;
        this.updateLayout();
    }

    @HostListener('window:resize')
    //TODO:  What should the debounce time be for resize?
    updateLayout() {
        //debounce resize, wait for resize to finish before doing stuff
        if (this.updateLayoutTimeout) {
            clearTimeout(this.updateLayoutTimeout);
        }
        this.updateLayoutTimeout = setTimeout(
            (() => {
                this.recalcMinHeightFormula();
            }).bind(this),
            50
        );
    }

    private recalcMinHeightFormula() {
        if (this._minBodyHeight && this._minBodyHeight.toLowerCase() == 'fill-remaining') {
            this._minBodyHeightFormula =
                'calc( 100vh - ' + (getHtmlElementPosition(this.pageContentElement.nativeElement).y + 15) + 'px )';
        } else {
            this._minBodyHeightFormula = this._minBodyHeight;
        }
        // console.log(`RESIZE: Panel.recalMinHeightFormula: ${this._minBodyHeightFormula}`);
    }

    toggleCollapse() {
        if (this.allowCollapse) {
            this.collapsed = !this.collapsed;
        }
    }

    get badgeText(): string {
        return this._badgeText;
    }

    constructor(private store: Store) { }

    changeLayout(layout: SectionLayoutType) {
        if (this.pageSection) {
            this.store.dispatch(new SetSectionLayout(this.pageSection.Section_ID, layout));
        }
    }
}
